<template>
  <div>
    <div>
      <span v-if="isStandardDeliveryBeforeChristmas" data-allow-mismatch="text">
        {{
          i18n(translations.freeShippingBeforeChristmas, {
            earliest: freeEarliestArrivalDate,
            latest: freeLatestArrivalDate,
          })
        }}
      </span>

      <FormattedMessage
        v-else-if="shouldDisplayFreeShippingWithDates"
        :definition="translations.freeShipping"
      >
        <template #dates>
          <span data-allow-mismatch="text">
            {{
              i18n(translations.freeShippingDates, {
                earliest: freeEarliestArrivalDate,
                latest: freeLatestArrivalDate,
              })
            }}
          </span>
        </template>
      </FormattedMessage>

      <span
        v-else-if="shouldDisplayFreeShippingWithoutDates"
        data-allow-mismatch="text"
      >
        {{ i18n(translations.freeShippingWithoutDates) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { useDeliveryBeforeChristmas } from '~/scopes/product-core/composables/useDelivery/useDeliveryBeforeChristmas/useDeliveryBeforeChristmas'
import { useDeliveryDateAdjustment } from '~/scopes/product-core/composables/useDelivery/useDeliveryDateAdjustement/useDeliveryDateAdjustement'

import translations from '../../ItemShipping.translations'

const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
}

const props = defineProps<{
  shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
}>()

const i18n = useI18n()

const deliveryDateAdjustment = useDeliveryDateAdjustment()
const { isStandardDeliveryBeforeChristmas } = useDeliveryBeforeChristmas(
  props.shipping,
)

const shouldDisplayFreeShippingWithoutDates = computed(() => {
  return isEmpty(props.shipping?.free)
})

const shouldDisplayFreeShippingWithDates = computed(() => {
  return !isEmpty(props.shipping?.free)
})

const freeEarliestArrivalDate = computed(() => {
  return props.shipping?.free
    ? i18n.date(
        deliveryDateAdjustment(props.shipping.free.earliestArrivalDate),
        DATE_FORMAT,
      )
    : null
})

const freeLatestArrivalDate = computed(() => {
  return props.shipping?.free
    ? i18n.date(new Date(props.shipping.free.latestArrivalDate), DATE_FORMAT)
    : null
})
</script>
